import { render, staticRenderFns } from "./SalesPerProducts.vue?vue&type=template&id=45160ee9"
import script from "./SalesPerProducts.vue?vue&type=script&lang=js"
export * from "./SalesPerProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports